import { useLocation } from "react-router-dom";
import KycDetails from "../../components/kycDetails/KycDetails";

function KycDetailsPage() {
    const location = useLocation();
    return (
        <>
            <KycDetails key={location.key} />
        </>
    );
}

export default KycDetailsPage;

